import React from "react";
import "./styles/Home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="home-container">
      {/* Header Section */}
      <header className="home-header">
        <h1>Welcome Back, Musician!</h1>
        <Link to="/campaigns">
          <button className="start-campaign-btn">Start Campaign</button>
        </Link>
      </header>

      {/* Quick Access Section */}
      <section className="quick-access">
        <div className="access-card">
          <h3>View Campaigns</h3>
          <p>Check and manage your past email campaigns.</p>
        </div>
        <div className="access-card">
          <h3>Gmail Accounts</h3>
          <p>Manage your connected Gmail accounts for sending.</p>
        </div>
        <div className="access-card">
          <h3>Statistics</h3>
          <p>Analyze email open rates, click rates, and engagement.</p>
        </div>
      </section>
    </div>
  );
};

export default Home;